import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@mantine/core';
import { PatternFormat } from 'react-number-format';
import FormSection from '../../common/FormSection';
import AppFlexbox from '../../common/AppFlexbox';
import AppStack from '../../common/AppStack';
import { Context as AuthContext } from '../../../providers/AuthContextProvider';
import { triggerNotification } from '../../../helpers/notification';

const ContactInformationForm = ({ onClose, isMobileOrSmaller }) => {
  const { state, updateProfile } = useContext(AuthContext);
  const [formState, setFormState] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    avatar: '',
    isLoading: false
  });
  const { user } = state.userData;

  useEffect(() => {
    if (user) {
      const fullName = user.name.split(' ');
      setFormState({
        lastName: fullName.pop(),
        firstName: fullName.join(' '),
        phone: user.phone,
        avatar: user.avatar,
        isLoading: false
      });
    }
  }, [user]);

  return (
    <FormSection
      isLoading={formState.isLoading}
      onCancel={onClose}
      onSubmit={() => {
        setFormState({
          ...formState,
          isLoading: true
        });
        updateProfile(
          formState,
          () => {
            triggerNotification('Contact info updated!', 'Success', 'green');
            onClose();
          },
          (e) => {
            triggerNotification(e);
            setFormState({
              ...formState,
              isLoading: false
            });
          }
        );
      }}
      submitTitle="Save Changes"
    >
      <AppStack>
        <AppFlexbox
          style={{
            flex: 1,
            flexDirection: isMobileOrSmaller ? 'column' : 'row'
          }}
        >
          <TextInput
            disabled={formState.isLoading}
            label="First Name"
            onChange={(e) =>
              setFormState({
                ...formState,
                firstName: e.currentTarget.value
              })
            }
            required
            style={{ flex: 1 }}
            value={formState.firstName}
          />
          <TextInput
            disabled={formState.isLoading}
            label="Last Name"
            onChange={(e) =>
              setFormState({
                ...formState,
                lastName: e.currentTarget.value
              })
            }
            required
            style={{ flex: 1 }}
            value={formState.lastName}
          />
        </AppFlexbox>

        <PatternFormat
          customInput={TextInput}
          disabled={formState.isLoading}
          format="+1 (###) ###-####"
          label="Phone Number"
          mask="_"
          name="phoneNumber"
          onValueChange={(values) => {
            setFormState({
              ...formState,
              phone: values.value
            });
          }}
          style={{ flex: 1 }}
          styles={{
            label: {
              fontSize: 16,
              fontWeight: 500
            }
          }}
          value={formState.phone}
        />
      </AppStack>
    </FormSection>
  );
};

ContactInformationForm.propTypes = {
  isMobileOrSmaller: PropTypes.bool,
  onClose: PropTypes.func
};

export default ContactInformationForm;
